export type ErrorContext = Record<string, unknown>;

export class AppError extends Error {
    constructor(
        message: string,
        public context?: ErrorContext,
    ) {
        super(message);

        // Maintains proper stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AppError);
        }
    }
}

export const isUserRejectionError = (error: Error): boolean => {
    return (
        error.message.toLowerCase().includes("user rejected") ||
        error.message.toLowerCase().includes("user denied") ||
        error.message.toLowerCase().includes("rejected by user")
    );
};
